const FIRST_TOUCH_KEY = "thecoach_first_touch";
const LAST_TOUCH_KEY = "thecoach_last_touch";
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;

export interface CampaignAttribution {
  source?: string;
  medium?: string;
  campaign?: string;
  gclid?: string;
  fbclid?: string;
  landingPage?: string;
  referrer?: string;
  capturedAt: number;
}

function normalize(value: string | null) {
  const trimmed = value?.trim();
  return trimmed ? trimmed.slice(0, 300) : undefined;
}

function parseStored(key: string): CampaignAttribution | null {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const value = JSON.parse(raw) as CampaignAttribution;
    if (!value.capturedAt || Date.now() - value.capturedAt > MAX_AGE_MS) {
      window.localStorage.removeItem(key);
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

export function captureCampaignAttribution() {
  const params = new URLSearchParams(window.location.search);
  const gclid = normalize(params.get("gclid"));
  const fbclid = normalize(params.get("fbclid"));
  const explicitSource = normalize(params.get("utm_source"));
  const source =
    explicitSource || (gclid ? "google" : fbclid ? "meta" : undefined);
  const medium =
    normalize(params.get("utm_medium")) ||
    (gclid || fbclid ? "paid" : undefined);
  const campaign = normalize(params.get("utm_campaign"));

  if (!source && !medium && !campaign && !gclid && !fbclid) return;

  const attribution: CampaignAttribution = {
    source,
    medium,
    campaign,
    gclid,
    fbclid,
    landingPage: `${window.location.pathname}${window.location.search}`,
    referrer: normalize(document.referrer),
    capturedAt: Date.now(),
  };

  if (!parseStored(FIRST_TOUCH_KEY)) {
    window.localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(attribution));
  }
  window.localStorage.setItem(LAST_TOUCH_KEY, JSON.stringify(attribution));
}

export function readCampaignAttribution(): CampaignAttribution | null {
  return parseStored(LAST_TOUCH_KEY) || parseStored(FIRST_TOUCH_KEY);
}
